import _sfc_main from "./component-library166.mjs";
import "./component-library167.mjs";
import normalizeComponent from "./component-library81.mjs";
var _sfc_render = function render() {
  var _a;
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.availableState ? _c("div", { staticClass: "availability-information" }, [_c("div", { staticClass: "availability-information__text" }, [_c("strong", { staticClass: "availability-information__stock", class: `availability-information__stock--${_setup.availableState.modifier}` }, [_vm._v(" " + _vm._s(_setup.availableState.text) + " ")]), (((_a = _vm.availability) == null ? void 0 : _a.stock) || 0) > 0 && _setup.availableState.deliveryTime ? _c("span", { staticClass: "availability-information__time" }, [_vm._v(" | Lieferzeit: " + _vm._s(_setup.availableState.deliveryTime) + " ")]) : _vm._e()]), _vm._t("delivery-availability-mail")], 2) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "90344d19",
  null,
  null
);
const availabilityInformation = __component__.exports;
export {
  availabilityInformation as default
};
